import classNames from 'classnames'
import { ReactNode } from 'react'

import { MODAL_WRAPPER_X_PADDING } from '@apps-common/components/modals/modal/ModalContainer'

interface IProps {
  classes?: string
  children: ReactNode
}

export const ModalHeaderContainer: React.FC<IProps> = ({ classes, children }) => (
  <div
    className={classNames(
      classes,
      MODAL_WRAPPER_X_PADDING,
      'absolute w-full left-0 top-0 bg-surface-2/30 backdrop-blur-md z-[5] pb-[20px]'
    )}
  >
    <div className='pt-[1rem]'>{children}</div>
  </div>
)
